var seventhgeneration = {
  name: 'Seventh Generation Organic All-Purpose Natural Cleaner',
  price: 299,
  manufacturer: "Seventh Generation",
  description: "A favorite go-to-cleaner for cutting grease, grime and dirt everywhere in your home. See for yourself why fans swear by it.",
  inStock: true,
  url: "https://www.seventhgeneration.com/all-purpose-cleaner?v=69"
};

var wholefoods = {
  name: 'Whole Foods Market All-Purpose Concentrated Cleaner',
  price: 399,
  manufacturer: "Whole Foods",
  description: "With pine essential oil, this is the hardest working partner in your cleaning closet for floors, sinks, counters, bathtubs and toilets. Rated yellow on the Eco-Scale.",
  inStock: false,
  url: "http://www.wholefoodsmarket.com/blog/spring-cleaning-greener-cleaners"
};

var ecome = {
  name: 'Eco-Me Natural All Purpose Cleaner',
  price: 914,
  manufacturer: "Eco-Me",
  description: "Safely clean dirt, grease, or other food-grade stains without harsh chemicals or fumes making this cleaner great for homes with children and pets",
  inStock: true,
  url: "https://www.amazon.com/Eco-Me-All-Purpose-Spray-Cleaner/dp/B002K627XA"
};

var toms = {
  name: 'Tom’s of Maine Natural Toothpaste',
  price: 429,
  manufacturer: "Tom’s of Maine",
  description: "Authentic natural ingredients and Whitens with naturally sourced silicas",
  inStock: true,
  url: "https://www.amazon.com/Toms-Maine-Antiplaque-Fluoride-Free-Toothpaste/dp/B00JUJ1E0W"
};

var deodorant = {
  name: 'Crystal Body Deodorant Stick, Fragrance Free',
  price: 719,
  manufacturer: "CRYSTAL Deodorant",
  description: "Perfect for men, women and teens, this natural mineral salt deodorant can last over a year with daily suggested use. Moisten the top of the stone before each use.",
  inStock: true,
  url: "https://www.amazon.com/CRYSTAL-BODY-DEODORANT-Stick-Unscented/dp/B000L978FU"
};


var products = [seventhgeneration, wholefoods, ecome, toms, deodorant];

module.exports = products;
